<template>
  <div :class="classModifier">
    <transition name="slide">
      <nav-browse :key="`${rotationIndex}-${isLayoutMobile}`"></nav-browse>
    </transition>
  </div>
</template>

<script src="./app-secondary-nav.js"></script>
<style src="./app-secondary-nav.scss" lang="scss"></style>
